import { Dialog } from "@marketing-sites/ui/primitives";
import { cn } from "@marketing-sites/utils/cn";

export function Popup({
  children,
  closeButton,
  className,
}: {
  children: React.ReactNode;
  closeButton?: React.ReactNode;
  className?: string;
}) {
  return (
    <Dialog.Popup
      className={cn(
        "w-full self-end shadow-2xl",
        "max-h-[calc(100dvh-4rem)]",
        "md:max-h-[calc(100vh-2rem)] md:w-[min(40rem,calc(100vw-2rem))] md:self-center",
        className,
      )}
      closeButton={closeButton}
    >
      {children}
    </Dialog.Popup>
  );
}
